<script setup lang="ts">
import type { StrapiBlockParagraph } from '@nimbus/types'

const props = defineProps<StrapiBlockParagraph>()
</script>

<template>
    <p>
        <NimbusStrapiBlockRenderer :content="props.children" :new-tab-links="props?.newTabLinks" />
    </p>
</template>
